export * from './news';


// WEBPACK FOOTER //
// ./src/app/news/models/index.ts